<template>
    <div class="backmain">
        <div>
            <el-row>
                <el-col :span="12" style="padding-right: 20px;text-align: center;">
                    <el-image style="width: 70%;margin:0 auto" :src="url9" :preview-src-list="srcList9">
                    </el-image>
                    <!-- <img src="https://hjzhpt.hzhjny.com/mnt/device/file/product15.png" alt="" class="imgsize"> -->
                </el-col>
                <el-col :span="12" style="padding-right: 20px;">
                    <div class="detailtitle">便携式红外测温成像仪</div>
                    <div class="detaildesr">
                        便携式测温热像仪配备了高灵敏度红外探测器、可见光相机、多功能红外镜头、激光测距及GPS定位系统，帮助用户快速清晰聚焦目标热图像，智能识别热故障点，
                        协助故障诊断。具备测温精确、成像清晰、简单易用、轻巧便携等优点，支持快速判断环境中的高、低温情况，支持一键抓拍与录像功能。
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-tabs v-model="activeNames">
            <el-tab-pane label="产品描述" name="first">
                <div class="productdesr">
                    便携式测温热像仪配备了高灵敏度红外探测器、可见光相机、多功能红外镜头、激光测距及GPS定位系统，帮助用户快速清晰聚焦目标热图像，智能识别热故障点，
                    协助故障诊断。具备测温精确、成像清晰、简单易用、轻巧便携等优点，支持快速判断环境中的高、低温情况，支持一键抓拍与录像功能。
                </div>
            </el-tab-pane>
            <el-tab-pane label="产品特色" name="second">
                <div class="productdesr" style="text-indent: 0px;">
                    ·高性能红外机芯：分辨率 384x288/640x480可选； <br>
                    ·测温性能卓越：精密高清的红外镜头系统具有高分辨率和连续自动对焦功能，即使从较远距离处也能获得精确的测量值；<br>
                    ·丰富功能：配备可编程按钮、敏捷的图形用户界面和实时图像增强功能，支持一键抓拍、自动聚焦、LED灯补光等多种专业特性。
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<style scoped>
    .backmain {
        width: 100%;
        background: white;
        padding-left: 20px;
    }


    .detailtitle {
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .detaildesr {
        line-height: 30px;
        font-size: 14px;
        color: #999;
    }

    .productdesr {
        font-size: 14px;
        text-indent: 28px;
        color: #666;
        line-height: 30px;
    }
</style>

<script>
    export default {
        data() {
            return {
                input1: '',
                input2: "",
                textarea2: '',
                size: 'medium',
                url9: 'https://hjzhpt.hzhjny.com/mnt/device/file/product33.png',
                srcList9: [
                    'https://hjzhpt.hzhjny.com/mnt/device/file/product33.png',
                ],


                activeNames: 'first',
            }
        },
        methods: {

        },
    }
</script>